import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import "../components/Navbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faTimes, faBars } from "@fortawesome/free-solid-svg-icons";
import { CONTACT_INFO } from "../constants/contact";

function Navbar() {
  const [click, setClick] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav className={`navbar fixed-top ${scrolled ? "navbar-scrolled" : ""}`}>
        <div className="navbar-container container-fluid">
          <Link to="/" className="nav-logo">
            <img
              src="../images/artel_logo.png"
              alt="logo"
              onClick={closeMobileMenu}
            />
          </Link>
          <div className="menu-icon">
            <FontAwesomeIcon
              icon={click ? faTimes : faBars}
              onClick={handleClick}
              className="burger-icon"
            />
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className="nav-item">
              <NavLink to="/" className={({ isActive }) => (isActive ? "nav-links active" : "nav-links")} onClick={closeMobileMenu}>
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/about" className={({ isActive }) => (isActive ? "nav-links active" : "nav-links")} onClick={closeMobileMenu}>
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/services" className={({ isActive }) => (isActive ? "nav-links active" : "nav-links")} onClick={closeMobileMenu}>
                Services
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/contact" className={({ isActive }) => (isActive ? "nav-links active" : "nav-links")} onClick={closeMobileMenu}>
                Contact
              </NavLink>
            </li>
            <li className="nav-item">
                <a
                  href={CONTACT_INFO.phoneHref}
                  className="call-btn"
                  onClick={closeMobileMenu}
                >
                  <FontAwesomeIcon className="icon-phone" icon={faPhone} />
                  <span> Call Us</span>
                </a>
            </li>
            <hr className="burger_call_line" />
            <li className="nav-item burger_call">
              <p>Free Call In U.S.A</p>
              <a 
              href={CONTACT_INFO.phoneHref}
              className="call-link"
              onClick={closeMobileMenu}
              >
              {CONTACT_INFO.phoneDisplay}
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
